import React, { useContext } from 'react'
import styled from 'styled-components'
import { bigPadding, getAssetLink } from '../common/utils'
import i18n from 'live/services/i18n'
import { ParamsContext } from './qualityMonitoring'

export function BreadCrumb({ analysisType }: { analysisType: AnalysisTypes | '' }): JSX.Element {
    const urlParams = useContext(ParamsContext).split('/')

    return (
        <StyledBreadCrumb
            style={
                {
                    '--padding': urlParams.length === 6 || analysisType ? bigPadding + 'px' : '14px'
                } as React.CSSProperties
            }
        >
            {urlParams.map((crumb, index) => {
                // the tab name is the frirst param, but it shouldn't appear in the breadcrum
                // so we removes the first element from the array that will render the crumbs
                if (!index) return
                // the last element doesn't need to be a link
                if (index === urlParams.length - 1) {
                    return <strong key={crumb}>{i18n(crumb).toUpperCase()}</strong>
                }
                const crumbPathArray = [...urlParams]
                // i added 1 because the path needs to be end at the current param.
                // this splice removes the other params starting at the next element in the array
                crumbPathArray.splice(index + 1)

                return (
                    <React.Fragment key={crumb}>
                        <a href={getAssetLink(crumbPathArray.join('/'))}>{i18n(crumb)}</a>
                        <span>/</span>
                    </React.Fragment>
                )
            })}
        </StyledBreadCrumb>
    )
}

export const breadCrumbHeight = 46

const StyledBreadCrumb = styled.div`
    width: 100%;
    background: ${({ theme }) => theme['gray-200']};
    border-bottom: 1px solid ${({ theme }) => theme['gray-300']};
    font-size: 16px;
    padding: 14px var(--padding);
    height: ${breadCrumbHeight}px;
    min-height: ${breadCrumbHeight}px;
    position: sticky;
    top: 35px;
    z-index: 2;

    a {
        color: ${({ theme }) => theme['blue-500']};
        text-decoration: none;
    }
    strong {
        color: ${({ theme }) => theme['gray-800']};
    }
    span {
        margin: 0 8px;
        color: ${({ theme }) => theme['gray-600']};
    }
`
